import { render, staticRenderFns } from "./w-pagination.vue?vue&type=template&id=bac3117e&"
import script from "./w-pagination.vue?vue&type=script&lang=ts&"
export * from "./w-pagination.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports